




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import Util from '@/lib/util';
import PageRequest from '@/store/entities/page-request';
import ListBase from '@/lib/listbase';
import Dealer from '@/store/entities/admin/dealer';
import ContactList from './contacts.vue';

class PageDealerConcatRequest extends PageRequest {
    dealer: number = null;
}

@Component({
    components: { ModalView, ContactList, FormBase},
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.dealer = Util.extend(true, {}, this.$store.state.dealer.editModel);
            obj.modalShow = val;
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class DealerForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    dealer: Dealer = new Dealer();
    pagerequest: PageDealerConcatRequest = new PageDealerConcatRequest();
    modalShow: boolean = false;
    formBase: boolean = true;
    listChips: Array<any> = [];
    emails: Array<any> = [];
    image: any = null;
    modalSetting: any = {
        entity: "dealer",
        title: 'Concesionario',
        width: "1100px",
        showForm: false,
    };
    
    items = [ 
        this.gItem({ type: 'text', prop: 'name', label: 'Nombre', size: 4, required: true }),
        this.gItem({ type: 'text', prop: 'location', label: 'Ubicacion', size: 2 }),
        this.gItem({ type: 'text', prop: 'code', label: 'Codigo SIMA', size: 2, required: true }),
        this.gItem({ type: 'text', prop: 'code2', label: 'Codigo 2', size: 2 }),
        this.gItem({ type: 'text', prop: 'document', label: 'RUC', size: 2, required: true }),
        this.gItem({ type: 'text', prop: 'business_name', label: 'Razon Social', size: 6, required: true }),
        this.gItem({ type: 'object', prop: 'zone_id', label: 'Zona', size: 3, required: true }),
        this.gItem({ type: 'object', prop: 'type_id', label: 'Tipo', size: 3, generalType: 'D_TYPES' }),
        this.gItem({ type: 'text', prop: 'address_sales', label: 'Direccion sala de ventas', icon: 'home', size: 6 }),
        this.gItem({ type: 'text', prop: 'address', label: 'Direccion taller de servicio', icon: 'home', size: 6 }),
        this.gItem({ type: 'ubigeo', prop: 'ubigeo', label: '', size: 6, entity: 'department', returnObject: true }),
        this.gItem({ type: 'phone', prop: 'phone1', label: 'Telefono central', size: 3 }),
        this.gItem({ type: 'phone', prop: 'phone2', label: 'Telefono de citas', size: 3 }),            
        this.gItem({ type: 'text', prop: 'description', label: 'Notas', size: 8 }),
        this.gItem({ type: 'number', prop: 'lat', label: 'Latitud', size: 1 }),
        this.gItem({ type: 'number', prop: 'lng', label: 'Longitud', size: 1 }),
        this.gItem({ type: 'active', size: 2 }),
        //this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 12 }),
    ]        
    //photo_facade: string;
    //photo: string;

    remove(item) {
        this.emails.splice(this.emails.indexOf(item), 1)
        this.emails = [...this.emails]
    }

    get showContacts() {
        return this.$store.state.dealer.editModel.id > 0;
    }

    async getContacts() {
        await this.$store.dispatch({
            type: 'dealercontact/getAll',
            data: { dealer: this.$store.state.dealer.editModel.id }
        });
    }
    
    async initForm() {   
        this.emails = [];
        if (this.$store.state.dealer.editModel.id > 0) {
            this.$store.commit('dealercontact/setDealer', this.$store.state.dealer.editModel.id);
            await this.getContacts();

            if (this.dealer.email!=null)
                this.emails = this.dealer.email.split(',');
        }
    }

    async save() {
        if ((this.$refs.entityForm1 as any).validate()) {
            let model = Util.extend(true, {}, this.dealer);
            model.email = this.emails.join(',');
            
            if (this.dealer.ubigeo != null) {
                model.department_id = this.dealer.ubigeo.department;
                model.province_id = this.dealer.ubigeo.province;
                model.district_id = this.dealer.ubigeo.district;
            }
            
            await this.$store.dispatch({
                type: 'dealer/' + (this.dealer.id > 0 ? 'update' : 'create'),
                data: model
            });
            this.$emit('save-success');
            this.cancel();
            if (this.dealer.id > 0)
                Util.abp.notify.success(this, 'Informacion de Concesionario actualizada!');
            else
                Util.abp.notify.success(this, 'El Concesionario ha sido creada!');

            this.$store.commit('dealer/setActiveList', []);
            await this.$store.dispatch({
                type: 'dealer/getAllActive',
                data: { force: true }
            });
        }
    }

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
